import { useConfigContext } from '../config/ConfigContext';

export const usePortalHrefs = () => {
  const config = useConfigContext();
  if (!config) {
    return {};
  }
  const { returnTo, accountPortal } = config.authentication;
  const [auth, editProfile, logout, changePassword] = [
    '/service_login',
    '/profile/edit',
    '/logout',
    '/account/password-change',
  ].map((path) => {
    const url = new URL(path, accountPortal);
    url.searchParams.set('return_to', returnTo);
    return url.href;
  });

  return {
    auth,
    editProfile,
    logout,
    changePassword,
  };
};
